
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 85.333 512 341.333"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#6DA544","d":"M0 85.337h512v341.326H0z"}}),_c('path',{attrs:{"fill":"#FFDA44","d":"M0 85.337h512v113.775H0z"}}),_c('path',{attrs:{"fill":"#D80027","d":"M0 312.888h512v113.775H0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M384 227.261h-97.783L256 134.265l-30.217 92.997H128l79.108 57.475-30.217 92.998L256 320.925l79.108 56.81-30.217-92.998L384 227.261z"}})])
          )
        }
      }
    